export function onCaptchaReady(callback) {
  if (!window.grecaptcha || !window.grecaptcha.ready) {
    setTimeout(() => onCaptchaReady(callback), 250);
    return;
  }
  window.grecaptcha.ready(callback);
}
